import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

const ProtectedRoute = ({ children, allowedRole }) => {
  const { userRole } = useContext(AuthContext);


  if (!userRole) {
    return <Navigate to="/signin" replace />;
  }

  if (userRole !== allowedRole) {
    return <Navigate to="/signin" replace />;
  }

  return children;
};

export default ProtectedRoute;